/* eslint-disable react/prop-types */
import React, { Component, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode.react'
import { jsPDF } from 'jspdf'

import './HowToUseAppGuide.scss'

import HorizontalLogo from '../../common/logoSVGs/HorizontalLogo'
import registrationMockup from './01-register-for-account.png'
import downloadMockup from './02-download-mobile-app.png'
import featuresMockup from './03-app-features.png'
// import qrCircleOne from './qr-code-1-circle.png';
// import qrCircleTwo from './qr-code-2-circle.png';

const MOBILE_DOWNLOAD_LINK = 'https://qrco.de/bbQ6EO'
const MOBILE_DOWNLOAD_LINK_SHORT =
  MOBILE_DOWNLOAD_LINK.substring(MOBILE_DOWNLOAD_LINK.indexOf('://') + 3)
const FEATURES = [
  {
    titleKey: 'reports.howToUseAppGuide.features.announcements.title',
    descKey: 'reports.howToUseAppGuide.features.announcements.desc',
  },
  {
    titleKey: 'reports.howToUseAppGuide.features.playGolf.title',
    descKey: 'reports.howToUseAppGuide.features.playGolf.desc',
  }, {
    titleKey: 'reports.howToUseAppGuide.features.trainSkills.title',
    descKey: 'reports.howToUseAppGuide.features.trainSkills.desc',
  }, {
    titleKey: 'reports.howToUseAppGuide.features.learnSkills.title',
    descKey: 'reports.howToUseAppGuide.features.learnSkills.desc',
  }, {
    titleKey: 'reports.howToUseAppGuide.features.globalChallenge.title',
    descKey: 'reports.howToUseAppGuide.features.globalChallenge.desc',
  },
]

class HowToUseAppGuide extends Component {

  state = {
    downloadPDFLoader: false,
  }

  _generateFeaturesList = () => {
    const { t } = this.props
    return (
      FEATURES.map((item, idx) => (
        <Fragment key={idx}>
          <h6 id={'title' + idx}>{t(item.titleKey)}</h6>
          <p id={'desc' + idx}>{t(item.descKey)}</p>
        </Fragment>
      ))
    )
  }

  _getHowToUseAppPDF = () => {
    this.setState({ downloadPDFLoader: true }, () => {
      const report = document.getElementById('how-to-use-app-page')
      html2canvas(report, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        // const pdf = new window.jspdf.jsPDF("p", "in", [8.5, 11], true);
        const pdf = new jsPDF({
          unit: 'in',
          format: [8.5, 11],
          compress: true,
        })
        pdf.addImage(imgData, 'PNG', 0, 0, 8.5, 11, '', 'FAST')
        pdf.save('How-to-Use-Op-36-Guide')
        this.setState({ downloadPDFLoader: false })
      })

      // html2canvas(report, {
      //   scale: 2,
      //   onclone: function(clone) {
      //     clone.getElementById('how-to-use-app-page').style.display = 'block';
      //   }
      // }).then((canvas) => {
      //   const imgData = canvas.toDataURL("image/png");
      //   const pdf = new window.jspdf.jsPDF("p", "in", [8.5, 11], true);
      //   pdf.addImage(imgData, "PNG", 0, 0, 8.5, 11, "", "FAST");
      //   pdf.save("How-to-Use-Op-36-Guide");
      //   this.setState({ downloadPDFLoader: false });
      // });
    })
  }

  render() {
    const { commId, t } = this.props
    const { downloadPDFLoader } = this.state

    const url = window.location.origin

    const regFormLink = `${url}/join-community/${commId}`
    const regFormLinkShort = regFormLink.substring(regFormLink.indexOf('://') + 3)

    return (
      <div className='how-to-use-app-wrapper'>
        <h2>{t('reports.howToUseAppGuide.intro')}</h2>
        <button
          className='btn btn-primary'
          onClick={this._getHowToUseAppPDF}
          disabled={downloadPDFLoader}
        >
          <i className='fa fa-file-pdf-o' aria-hidden='true' />{' '}
          {downloadPDFLoader ? t('reports.howToUseAppGuide.downloadingGuide') : t('reports.howToUseAppGuide.downloadGuide')}
        </button>
        <div id='how-to-use-app-page-scroll-container'>
          <div id='how-to-use-app-page'>
            <div id='how-to-use-app-page-content'>
              <div className='how-to-use-app-title'>
                <h3>{t('reports.howToUseAppGuide.title')}</h3>
                <HorizontalLogo colorScheme='light' classes='how-to-use-app-title-logo'/>
              </div>
              <div className='how-to-use-app-steps'>
                <div className='how-to-use-app-part-1'>
                  <div className='how-to-use-app-step-1'>
                    <h4>{t('reports.howToUseAppGuide.step1.heading')}</h4>
                    <div
                      className='how-to-use-app-qr-phone'
                      id='how-to-use-app-qr-phone-1'>
                      <img
                        className='how-to-use-app-qr-mockup'
                        src={registrationMockup}
                        alt={t('reports.howToUseAppGuide.step1.imageAlt')} />
                      <QRCode
                        value={`${url}/join-community/${commId}`}
                        fgColor={'#1d2933'}
                        renderAs={'svg'}
                        includeMargin />
                    </div>
                    <p className='how-to-use-app-url'>
                      <a href={regFormLink} target='_blank' rel='noreferrer'>{regFormLinkShort}</a>
                    </p>
                    <p>{t('reports.howToUseAppGuide.step1.scanQr')} <strong>{t('reports.howToUseAppGuide.step1.scanQrEmphasis')}</strong></p>
                  </div>
                  <i className='fa fa-arrow-right' aria-hidden='true' />
                  <div className='how-to-use-app-step-2'>
                    <h4>{t('reports.howToUseAppGuide.step2.heading')}</h4>
                    <div
                      className='how-to-use-app-qr-phone'
                      id='how-to-use-app-qr-phone-2'>
                      <img
                        className='how-to-use-app-qr-mockup'
                        src={downloadMockup}
                        alt={t('reports.howToUseAppGuide.step2.imageAlt')} />
                      <QRCode
                        value={MOBILE_DOWNLOAD_LINK}
                        fgColor={'#1d2933'}
                        renderAs={'svg'}
                        includeMargin />
                    </div>
                    <p className='how-to-use-app-url'>
                      <a href={MOBILE_DOWNLOAD_LINK} target='_blank' rel='noreferrer'>
                        {MOBILE_DOWNLOAD_LINK_SHORT}
                      </a>
                    </p>
                    <p>
                      {t('reports.howToUseAppGuide.step2.scanQrPrefix')}
                      {' '}
                      <strong>{t('reports.howToUseAppGuide.step2.scanQrEmphasis')}</strong>
                      {' '}
                      {t('reports.howToUseAppGuide.step2.scanQrSuffix')}
                    </p>
                  </div>
                </div>
                <div className='how-to-use-app-part-2'>
                  <h4>{t('reports.howToUseAppGuide.step3.heading')}</h4>
                  <h5>{t('reports.howToUseAppGuide.step3.subheading')}</h5>
                  <div className='how-to-use-app-feature-wrapper'>
                    <img
                      className='how-to-use-app-feature-graphic'
                      src={featuresMockup}
                      alt={t('reports.howToUseAppGuide.step3.imageAlt')} />
                    <div className='how-to-use-app-feature-text'>
                      {this._generateFeaturesList()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(HowToUseAppGuide)
